import React, { useEffect, useRef } from 'react';
import L from 'leaflet';

function DeliveryMap({ delivery, driver }) {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const deliveryMarkerRef = useRef(null);
  const driverMarkerRef = useRef(null);
  const hasInitializedBounds = useRef(false); // Track if we've done initial centering

  // Initialize map
  useEffect(() => {
    if (!mapContainerRef.current || mapRef.current || !delivery) return;

    // Create map
    const map = L.map(mapContainerRef.current, {
      center: [delivery.latitude, delivery.longitude],
      zoom: 15,
      zoomControl: false,
    });
    mapRef.current = map;

    // Add tile layer
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
    }).addTo(map);

    // Create red icon for delivery point
    const redIcon = L.icon({
      iconUrl: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    });

    // Add delivery marker
    const deliveryMarker = L.marker([delivery.latitude, delivery.longitude], {
      icon: redIcon,
      title: 'Punto de Entrega',
    })
      .bindPopup(`<h3>${delivery.recipient_name}</h3>`)
      .addTo(map);
    
    deliveryMarkerRef.current = deliveryMarker;

    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, [delivery]);

  // Update driver marker
  useEffect(() => {
    if (!mapRef.current || !driver?.latitude || !driver?.longitude) return;

    const driverIcon = L.icon({
      iconUrl: `${process.env.PUBLIC_URL}/logo.png`,
      iconSize: [30, 30],
      iconAnchor: [15, 30],
      popupAnchor: [0, -30],
    });

    if (driverMarkerRef.current) {
      // Update existing marker position
      driverMarkerRef.current.setLatLng([driver.latitude, driver.longitude]);
    } else {
      // Create new driver marker
      const driverMarker = L.marker([driver.latitude, driver.longitude], {
        icon: driverIcon,
        title: 'Mi Ubicación',
      }).addTo(mapRef.current);
      
      driverMarkerRef.current = driverMarker;
    }

    // Only center map to show both markers on FIRST render
    // After that, let the user control the map view
    if (deliveryMarkerRef.current && driverMarkerRef.current && !hasInitializedBounds.current) {
      const bounds = L.latLngBounds([
        [driver.latitude, driver.longitude],
        [delivery.latitude, delivery.longitude]
      ]);
      mapRef.current.fitBounds(bounds, { padding: [50, 50] });
      hasInitializedBounds.current = true; // Mark as initialized
    }
  }, [driver, delivery]);

  return (
    <div 
      ref={mapContainerRef} 
      className="absolute inset-0 w-full h-full"
      style={{ zIndex: 0 }}
    />
  );
}

export default DeliveryMap;